import PropertyInstruction from "../../PropertyInstruction";
import {useApartment} from "../ApartmentContext";


const ApartmentPropertyInstruction = () => {
    const {propertyInstructions, updateApartment} = useApartment();

    return <PropertyInstruction propertyInstructions={propertyInstructions}
                                onSave={updateApartment} />
}


export default ApartmentPropertyInstruction;